import { render } from "./MarketingCampaign.modal.vue?vue&type=template&id=b47ad6c2"
import script from "./MarketingCampaign.modal.vue?vue&type=script&lang=js"
export * from "./MarketingCampaign.modal.vue?vue&type=script&lang=js"

import "./MarketingCampaign.modal.vue?vue&type=style&index=0&id=b47ad6c2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
